/**
 * CUBE - AJAX LIBRARY
 */
var countAjaxRunning = 0;
var csrfTokenInput = document.querySelector('input[name="csrfToken"]');
var csrfToken = csrfTokenInput && csrfTokenInput.value;
var csrfHeader = 'Csrf-Token';
module.exports = {
  get active() { return countAjaxRunning },
  /**
   * Prepare a GET request
   */
  get: function(url) {
    return new CubeAjax(url, 'GET')
  },
  /**
   * Prepare a POST request
   */
  post: function(url, params, isCartridge) {
    return new CubeAjax(url, 'POST', params, isCartridge)
  },
  /**
   * Encode a map of parameters to a string
   */
  encode: function(params) {
    return encodeURIComponent(Object.keys(params).map(function(k) { return k + '=' + params[k] }).join('&'));
  },

  form: function(url, params) {
    return new CubeAjax(url, 'POST', params, true)
  },

  mapToQueryString: serialize
}
/**
 * CubeAjax
 *
 * @param {any} url
 * @param {any} type {GET / POST}
 * @param {any} params
 * @returns
 */
function CubeAjax(url, type, params, isCartridge) {
  this._url = (url.match(/^http/)) ? url : [location.origin, tc_vars.env_language, 'ajax', url].join('/');
  this._type = type || 'GET';
  this._params = params;
  this._isCartridge = isCartridge || false;
  this._format = null;
  this._cbThen = function() { console.warn('Unhandled response from URL "'+this._url+'"'); };
  this._cbCatch = function() { console.warn('Unhandled error from URL "'+this._url+'"'); };
  return this;
}
/**
 * Called when the request has succeed
 */
CubeAjax.prototype.onSuccess = function(cb) { this._cbThen = cb; return this; };
/**
 * Called when the request has failed
 */
CubeAjax.prototype.onError = function(cb) { this._cbCatch = cb; return this; };
/**
 * Execute the request
 */
CubeAjax.prototype.call = function() {
  countAjaxRunning += 1
  var self = this;
  var req = new XMLHttpRequest();
  req.onload = function() {
    countAjaxRunning -= 1
    // RESPONSE OK
    if (req.status === 200 && self._cbThen) {
      var contentType = req.getResponseHeader('content-type');
      if (contentType.indexOf('application/json') > -1) { // JSON response
        var resp = JSON.parse(req.responseText);
        if (resp.error) self._cbCatch(resp)
        // Redirect if specified in responseTO
        else if(resp.isRedirect && resp.url) return document.location = resp.url;
        else self._cbThen(resp)
      } else if (contentType.indexOf('text/html') > -1) { // HTML response
        self._cbThen(req.responseText)
      } else {
        self._cbThen(req)
      }
    }
    // RESPONSE NOT OK
    else if (typeof self._cbCatch === "function") {
      self._cbCatch('['+self.reqType+'] Ajax request to '+self.reqUrl+' failed. (Status: '+req.status+')');
    }
  }
  req.open(self._type, self._url);
  if (csrfToken) {
    req.setRequestHeader(csrfHeader, csrfToken); 
  }
  if (this._params && typeof this._params === "object") {
    if (self._isCartridge === false) {
      req.setRequestHeader("Content-type", "application/json");
      req.send(JSON.stringify(this._params));
    } else {
      req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      req.send(serialize(this._params));
    }
  }
  else req.send();
}

function serialize(obj) {
  if (!obj) return '';

  return Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&');
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-ajax.js